export async function fetchLastOrderId() {
  return window.localStorage.getItem('lastOrderId')
}
